module.exports = __webpack_public_path__ + "static/media/login_banner.841e25aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_banner.png
// module id = 3233
// module chunks = 0